module.exports = __webpack_public_path__ + "static/ps-500-16de65ff49f38411bb40efa9d670a225.png";